import { createBrowserRouter, RouterProvider, useNavigate, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import Layout from './components/Layout';
import LoginPage from './components/LoginPage';
import { Toaster } from './components/ui/Sonner';

// Páginas
import DashboardPage from './pages/Dashboard';
import RelatoriosPage from './pages/Relatorios';
import ProdutosPage from './pages/Produtos';
import CategoriasPage from './pages/Categorias';
import MarcasPage from './pages/Marcas';
import VendasPage from './pages/Vendas';
import VendaDetalhesPage from './pages/VendaDetalhes';
import ClientesPage from './pages/Clientes';
import EtiquetasPage from './pages/Etiquetas';
import { AtividadesPage } from './pages/Atividades';
import AdministradoresPage from './pages/Administradores';
import InfluencersPage from './pages/Influencers';
import BlogPage from './pages/Blog';
import BannerPage from './pages/Banner';
import PaginasPage from './pages/Paginas';
import PerfilPage from './pages/Perfil';
import ProdutosClientePage from './pages/ProdutosCliente';
import { ConfiguracoesLojaPage } from './pages/ConfiguracoesLoja';
import { CuponsPage } from './pages/Cupons';

// Forms
import NovoProdutoForm from './forms/NovoProduto';
import NovoClienteForm from './forms/NovoCliente';
import NovoAdministradorForm from './forms/NovoAdministrador';
import NovoInfluencerForm from './forms/NovoInfluencer';
import NovoPostForm from './forms/NovoPost';
import NovoBannerForm from './forms/NovoBanner';
import NovaPaginaForm from './forms/NovaPagina';

import { useEffect } from 'react';

function LoginWithNav() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('sanctum_token');
    if (token) {
      navigate('/produtos', { replace: true });
    }
  }, [navigate]);

  return <LoginPage onLogin={() => navigate('/produtos')} />;
}

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginWithNav />,
  },
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/produtos" replace />,
      },
      {
        path: '/dashboard',
        element: <DashboardPage />,
      },
      {
        path: '/dashboard/analytics',
        element: <DashboardPage />,
      },
      {
        path: '/reports',
        element: <RelatoriosPage />,
      },
      {
        path: '/produtos',
        element: <ProdutosPage />,
      },
      {
        path: '/categorias',
        element: <CategoriasPage />,
      },
      {
        path: '/marcas',
        element: <MarcasPage />,
      },
      {
        path: '/cupons',
        element: <CuponsPage />,
      },
      {
        path: '/vendas',
        element: <VendasPage />,
      },
      {
        path: '/vendas/:id',
        element: <VendaDetalhesPage />,
      },
      {
        path: '/clientes',
        element: <ClientesPage />,
      },
      {
        path: '/clientes/:id',
        element: <ProdutosClientePage />,
      },
      {
        path: '/tags',
        element: <EtiquetasPage />,
      },
      {
        path: '/atividades',
        element: <AtividadesPage />,
      },
      {
        path: '/admins',
        element: <AdministradoresPage />,
      },
      {
        path: '/influencers',
        element: <InfluencersPage />,
      },
      {
        path: '/blog',
        element: <BlogPage />,
      },
      {
        path: '/blog/novo',
        element: <NovoPostForm onBack={() => window.history.back()} />,
      },
      {
        path: '/blog/:id',
        element: <NovoPostForm onBack={() => window.history.back()} />,
      },
      {
        path: '/banner',
        element: <BannerPage />,
      },
      {
        path: '/novo-banner',
        element: <NovoBannerForm onBack={() => window.history.back()} />,
      },
      {
        path: '/editar-banner/:id',
        element: <NovoBannerForm onBack={() => window.history.back()} />,
      },
      {
        path: '/page',
        element: <PaginasPage />,
      },
      {
        path: '/nova-pagina',
        element: <NovaPaginaForm onBack={() => window.history.back()} />,
      },
      {
        path: '/editar-pagina/:id',
        element: <NovaPaginaForm onBack={() => window.history.back()} />,
      },
      {
        path: '/perfil',
        element: <PerfilPage />,
      },
      {
        path: '/configuracoes-loja',
        element: <ConfiguracoesLojaPage />,
      },
      {
        path: '/clientes/:id/produtos',
        element: <ProdutosClientePage />,
      },
      // Forms - Novo
      {
        path: '/novo-produto',
        element: <NovoProdutoForm onBack={() => window.history.back()} />,
      },
      {
        path: '/editar-produto/:id',
        element: <NovoProdutoForm onBack={() => window.history.back()} />,
      },
      {
        path: '/novo-cliente',
        element: <NovoClienteForm onBack={() => window.history.back()} />,
      },
      {
        path: '/editar-cliente/:id',
        element: <NovoClienteForm onBack={() => window.history.back()} />,
      },
      {
        path: '/novo-administrador',
        element: <NovoAdministradorForm onBack={() => window.history.back()} />,
      },
      {
        path: '/editar-administrador/:id',
        element: <NovoAdministradorForm onBack={() => window.history.back()} />,
      },
      {
        path: '/novo-influencer',
        element: <NovoInfluencerForm onBack={() => window.history.back()} />,
      },
      {
        path: '/editar-influencer/:id',
        element: <NovoInfluencerForm onBack={() => window.history.back()} />,
      },
      {
        path: '*',
        element: <Navigate to="/produtos" replace />,
      },
    ],
  },
]);

export default function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" closeButton richColors />
    </AuthProvider>
  );
}
